import axios from "axios";
import { CheckLoginServer } from "../Helpers/CheckLogin";
import { BaseUrl } from "./Base";

const axiosInstance = axios.create({
  baseURL: BaseUrl,
  withCredentials: true,
});

export const GetCourse = (InstituteCourseId) => async (dispatch) => {
  try {
    dispatch({
      type: "CourseRequest",
      payload: { InstituteCourseId },
    });

    const { data } = await axiosInstance.get(
      `/api/institute/course/${InstituteCourseId}`
    );

    dispatch({
      type: "CourseSuccess",
      payload: data,
    });
  } catch (error) {
    CheckLoginServer(error?.response?.data, dispatch);
    dispatch({
      type: "CourseFailure",
      payload: error,
    });
  }
};

// Get Institute Course With Packages (Admin)
export const GetInstituteCourseWithPackages = (InstituteCourseId) => async (dispatch) => {
  try {
    dispatch({
      type: "GetInstituteCourseWithPackagesRequest",
    });

    const { data } = await axiosInstance.get(
      `/api/institute-course/${InstituteCourseId}/with-packages`
    );

    dispatch({
      type: "GetInstituteCourseWithPackagesSuccess",
      payload: data,
    });
  } catch (error) {
    CheckLoginServer(error?.response?.data, dispatch);
    dispatch({
      type: "GetInstituteCourseWithPackagesFailure",
      payload: error,
    });
  }
};

export const GetInstituteCoursesTimeSlots = (InstituteCourseId) => async (dispatch) => {
  dispatch({ type: "GetInstituteCoursesTimeSlotsRequest" });

  try {
      const response = await axiosInstance.get(
        `/api/institute/timeslots/${InstituteCourseId}`
      ); // Replace with actual API call
      dispatch({
          type: "GetInstituteCoursesTimeSlotsSuccess",
          payload: response.data, // The time slots data
      });
  } catch (error) {
      dispatch({
          type: "GetInstituteCoursesTimeSlotsFailure",
          payload: error.response?.data || error.message,
      });
  }
};

export const GetInstituteTrainingTimeSlots = (InstituteId) => async (dispatch) => {
  dispatch({ type: "GetInstituteCoursesTimeSlotsRequest" });

  try {
      const response = await axiosInstance.get(
        `/api/institute/trainingtimeslots/${InstituteId}`
      ); // Replace with actual API call
      dispatch({
          type: "GetInstituteCoursesTimeSlotsSuccess",
          payload: response.data, // The time slots data
      });
  } catch (error) {
      dispatch({
          type: "GetInstituteCoursesTimeSlotsFailure",
          payload: error.response?.data || error.message,
      });
  }
};

export const GetInstituteSideCoursesTimeSlots = (InsId) => async (dispatch) => {
  dispatch({ type: "GetInstituteSideCoursesTimeSlotsRequest" });

  try {
      const response = await axiosInstance.get(
        `/api/institute/InstituteSidetimeslots/${InsId}`
      ); // Replace with actual API call
      dispatch({
          type: "GetInstituteSideCoursesTimeSlotsSuccess",
          payload: response.data, // The time slots data
      });
  } catch (error) {
      dispatch({
          type: "GetInstituteSideCoursesTimeSlotsFailure",
          payload: error.response?.data || error.message,
      });
  }
};


export const GetLicenseTypeCourse = (LicenseTypeId) => async (dispatch) => {
  try {
    dispatch({
      type: "LicenceTypeCoursesRequest",
    });

    const { data } = await axiosInstance.get(
      `/api/LicenseType/courses/${LicenseTypeId}`
    );

    dispatch({
      type: "LicenceTypeCoursesSuccess",
      payload: data,
    });
  } catch (error) {
    CheckLoginServer(error?.response?.data, dispatch);
    dispatch({
      type: "LicenceTypeCoursesFailure",
      payload: error,
    });
  }
};
export const GetVehicleTypeCourse = (VehicleypeId) => async (dispatch) => {
  try {
    dispatch({
      type: "LicenceTypeCoursesRequest",
    });

    const { data } = await axiosInstance.get(
      `/api/vehicletype/courses/${VehicleypeId}`
    );

    dispatch({
      type: "LicenceTypeCoursesSuccess",
      payload: data,
    });
  } catch (error) {
    CheckLoginServer(error?.response?.data, dispatch);
    dispatch({
      type: "LicenceTypeCoursesFailure",
      payload: error,
    });
  }
};

export const GetEnrollCourseInfo = (EnrollCourseId) => async (dispatch) => {
  try {
    dispatch({
      type: "EnrollCourseRequest",
      payload: { InstituteCourseId: EnrollCourseId },
    });
    const { data } = await axiosInstance.get(
      `/api/institute/course/${EnrollCourseId}`
    );

    dispatch({
      type: "EnrollCourseSuccess",
      payload: data,
    });
  } catch (error) {
    CheckLoginServer(error?.response?.data, dispatch);
    dispatch({
      type: "EnrollCourseFailure",
      payload: error,
    });
  }
};

export const EnrollIntoCourse = (EnrollmentData) => async (dispatch) => {
  try {
    dispatch({
      type: "BuyCourseRequest",
    });
    const { data } = await axiosInstance.post(
      `/api/buy/course`,
      EnrollmentData
    );

    dispatch({
      type: "BuyCourseSuccess",
      payload: data,
    });
    // Navigate("/mycourses/enrolledcourses");
  } catch (error) {
    CheckLoginServer(error?.response?.data, dispatch);
    dispatch({
      type: "BuyCoursefailure",
      payload: error,
    });
  }
};

export const AdminEnrollLearnerWithoutPayment = (enrollmentPayload) => async (dispatch) => {
  try {
    dispatch({
      type: "AdminEnrollLearnerRequest",
    });
    const { data } = await axiosInstance.post(
      `/api/enroll-learner-without-payment`,
      enrollmentPayload
    );

    dispatch({
      type: "AdminEnrollLearnerSuccess",
      payload: data,
    });
    return { success: true, data };
  } catch (error) {
    CheckLoginServer(error?.response?.data, dispatch);
    dispatch({
      type: "AdminEnrollLearnerFailure",
      payload: error,
    });
    return { success: false, error: error?.response?.data || error };
  }
};

export const GetEnrolledCourses = () => async (dispatch) => {
  try {
    dispatch({
      type: "GetEnrolledCoursesRequest",
    });
    const { data } = await axiosInstance.get(`/api/enrollCourse`);

    dispatch({
      type: "GetEnrolledCoursesSuccess",
      payload: data,
    });
  } catch (error) {
    CheckLoginServer(error?.response?.data, dispatch);
    dispatch({
      type: "GetEnrolledCoursesFailure",
      payload: error,
    });
  }
};

// Admin Enrollment: Create enrollment request and send payment link email to learner
export const AdminEnrollLearner = (enrollmentRequestData) => async (dispatch) => {
  try {
    dispatch({
      type: "AdminEnrollLearnerRequest",
    });

    // Prepare FormData with all enrollment data (similar to learner enrollment)
    const formData = new FormData();
    
    // Append images if provided
    if (enrollmentRequestData.StudentImage) {
      formData.append("StudentImage", enrollmentRequestData.StudentImage);
    }
    if (enrollmentRequestData.LatestLicense) {
      formData.append("LatestLicense", enrollmentRequestData.LatestLicense);
    }
    if (enrollmentRequestData.LatestLicenseBack) {
      formData.append("LatestLicenseBack", enrollmentRequestData.LatestLicenseBack);
    }
    
    // Append enrollment data
    formData.append("CoursePackageId", enrollmentRequestData.CoursePackageId);
    formData.append("UserId", enrollmentRequestData.UserId);
    formData.append("EnrollmentData", JSON.stringify(enrollmentRequestData.EnrollmentData));
    formData.append("enrollmentStatus", enrollmentRequestData.enrollmentStatus || "InProgress"); // Default status for admin enrollment
    formData.append("inClassBatchId", enrollmentRequestData.selectedBatchId || "");
    
    // Append schedule data
    if (enrollmentRequestData.manualAndAutomaticScheduleSelection) {
      formData.append("ScheduleType", enrollmentRequestData.manualAndAutomaticScheduleSelection);
    }
    if (enrollmentRequestData.learnerFinalSchedule) {
      formData.append("LearnerFinalSchedule", JSON.stringify(enrollmentRequestData.learnerFinalSchedule));
    }
    
    // Append course start date
    if (enrollmentRequestData.courseStartDate) {
      formData.append("CourseStartDate", enrollmentRequestData.courseStartDate);
    }

    // Call admin enrollment API that creates enrollment request and sends payment link email
    const { data } = await axiosInstance.post(
      `/api/admin/enroll-learner`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    dispatch({
      type: "AdminEnrollLearnerSuccess",
      payload: data,
    });
    
    return { success: true, data };
  } catch (error) {
    CheckLoginServer(error?.response?.data, dispatch);
    const errorMessage = error?.response?.data?.message || error?.response?.data?.error || "Failed to create enrollment request";
    dispatch({
      type: "AdminEnrollLearnerFailure",
      payload: error,
    });
    
    // Return error object instead of throwing so component can handle it
    return { success: false, error: errorMessage };
  }
};

export const GetCompletedCourses = () => async (dispatch) => {
  try {
    dispatch({
      type: "GetEnrolledCoursesRequest",
    });
    const { data } = await axiosInstance.get(`/api/CompetedCourse`);

    dispatch({
      type: "GetEnrolledCoursesSuccess",
      payload: data,
    });
  } catch (error) {
    CheckLoginServer(error?.response?.data, dispatch);
    dispatch({
      type: "GetEnrolledCoursesFailure",
      payload: error,
    });
  }
};

export const GetSingleEnrolledCourse = (EnrollmentId) => async (dispatch) => {
  try {
    dispatch({
      type: "GetSEnrolledCoursesRequest",
    });
    const { data } = await axiosInstance.get(
      `/api/enrollCourse/${EnrollmentId}`
    );
    console.log("senrol", data);
    dispatch({
      type: "GetSEnrolledCoursesSuccess",
      payload: data,
    });
  } catch (error) {
    CheckLoginServer(error?.response?.data, dispatch);
    dispatch({
      type: "GetSEnrolledCoursesFailure",
      payload: error,
    });
  }
};

export const GetStudentTimeTableForTheEnrolledCourse = (EnrollmentId) => async (dispatch) => {
  try {
    console.log("EnrollmentId in GetStudentTimeTableForTheEnrolledCourse is:",EnrollmentId)
    dispatch({
      type: "GetSEnrolledCourseTimeTableRequest",
    });
    const { data } = await axiosInstance.get(
      `/api/enrollCourseStudentTimeTable/${EnrollmentId}`
    );
    console.log("senrol", data);
    dispatch({
      type: "GetSEnrolledCourseTimeTableRequestSuccess",
      payload: data,
    });
  } catch (error) {
    CheckLoginServer(error?.response?.data, dispatch);
    dispatch({
      type: "GetSEnrolledCourseTimeTableRequestFailure",
      payload: error,
    });
  }
};

export const GetSEnrolledCourse_ForInsA =
  (EnrollmentId) => async (dispatch) => {
    try {
      dispatch({
        type: "GetSEnrolledCoursesRequest",
      });
      const { data } = await axiosInstance.get(`/api/Enrolled/${EnrollmentId}`);

      dispatch({
        type: "GetSEnrolledCoursesSuccess",
        payload: data,
      });
    } catch (error) {
      CheckLoginServer(error?.response?.data, dispatch);
      dispatch({
        type: "GetSEnrolledCoursesFailure",
        payload: error,
      });
    }
  };

export const GetCourseProgress = (EnrollmentId) => async (dispatch) => {
  try {
    dispatch({
      type: "GetSEnrolledCoursesRequest",
    });
    const { data } = await axiosInstance.get(
      `/api/courseprogress/${EnrollmentId}`
    );

    dispatch({
      type: "GetSEnrolledCoursesSuccess",
      payload: data?.EnrolledCourse,
    });
    dispatch({
      type: "EnrolledCourseProgressSuccess",
      payload: data?.Progress,
    });
  } catch (error) {
    CheckLoginServer(error?.response?.data, dispatch);
    dispatch({
      type: "GetSEnrolledCoursesFailure",
      payload: error,
    });
  }
};

export const GetAdminCoursesA = (page) => async (dispatch) => {
  try {
    dispatch({
      type: "GetAdminCoursesRequest",
    });
    
    // Conditionally add page parameter only if it's provided
    const url = page ? `/api/courses?page=${page}` : `/api/courses`;
    const { data } = await axiosInstance.get(url);

    // Backend returns { courses: [...], pagination: {...} }
    dispatch({
      type: "GetAdminCoursesSuccess",
      payload: {
        courses: data.courses || data, // Handle both formats
        pagination: data.pagination || null
      }
    });
  } catch (error) {
    CheckLoginServer(error?.response?.data, dispatch);
    dispatch({
      type: "GetAdminCoursesFailure",
      payload: error,
    });
  }
};

export const GetAdminCourseA = (CoursePK) => async (dispatch) => {
  try {
    dispatch({
      type: "GetAdminCourseRequest",
    });
    const { data } = await axiosInstance.get(`/api/course/${CoursePK}`);

    dispatch({
      type: "GetAdminCourseSuccess",
      payload: data,
    });
  } catch (error) {
    CheckLoginServer(error?.response?.data, dispatch);
    dispatch({
      type: "GetAdminCourseFailure",
      payload: error,
    });
  }
};

export const GetRecommendedAdminCoursesA = () => async (dispatch) => {
  try {
    dispatch({
      type: "GetAdminCoursesRequest",
    });

    const { data } = await axiosInstance.get(`/api/course/forwards/`);
    let CoursesArr = data.map((value) => value.Course);
    CoursesArr = CoursesArr?.filter((value, Index, arr) => {
      let CheckVal = true;
      arr.forEach((Val, index) => {
        if (value?.CoursePK === Val?.CoursePK && Index > index)
          CheckVal = false;
      });

      return CheckVal === true;
    });

    dispatch({
      type: "GetAdminCoursesSuccess",
      payload: CoursesArr,
    });
  } catch (error) {
    CheckLoginServer(error?.response?.data, dispatch);
    dispatch({
      type: "GetAdminCoursesFailure",
      payload: error,
    });
  }
};

export const GetAboutInfoA = (EnrollmentId) => async (dispatch) => {
  try {
    dispatch({
      type: "GetAboutClientRequest",
    });
    const { data } = await axiosInstance.get(`/api/student/${EnrollmentId}`);
    console.log("data recieved is:",data)
    console.log("CoursePackage:", data?.EnrolledCourse?.CoursePackage);
    console.log("Student:", data?.EnrolledCourse?.User);
    console.log("CourseProgress:", data?.Progress);
    console.log("ScheduleTimeTable:", data?.EnrolledCourse?.ParsedSchedule);
    console.log("StudentInfo:", data?.StudentInfoData);

    // let StudentInfo = { ...data.EnrolledCourse.User };

    // StudentInfo.StudentInfo.DOB = new Date(
    //   StudentInfo?.StudentInfo?.DOB
    // ).toLocaleDateString();

    dispatch({
      type: "GetAboutClientSuccess",
      CoursePackage: data?.EnrolledCourse?.CoursePackage,
      Student: data?.EnrolledCourse?.User,
      // CourseProgress: data.EnrolledCourse.CourseProgress,
      CourseProgress: data?.Progress,

      ScheduleTimeTable: data?.EnrolledCourse?.ParsedSchedule,
      StudentInfo: data?.StudentInfoData,
    });
  } catch (error) {
    CheckLoginServer(error?.response?.data, dispatch);
    dispatch({
      type: "GetAboutClientFailure",
      payload: error,
    });
  }
};

export const GetEnrolledStudentCourseDetailsA = (EnrollmentId) => async (dispatch) => {
  try {
    dispatch({
      type: "GetAboutClientRequest",
    });
    const { data } = await axiosInstance.get(`/api/student/enrolledcourse/details/${EnrollmentId}`);
    console.log("data recieved is:",data)
    console.log("CoursePackage:", data?.EnrolledCourse?.CoursePackage);
    console.log("Student:", data?.EnrolledCourse?.User);
    console.log("CourseProgress:", data?.Progress);
    console.log("ScheduleTimeTable:", data?.EnrolledCourse?.ParsedSchedule);
    console.log("StudentInfo:", data?.StudentInfoData);

    // let StudentInfo = { ...data.EnrolledCourse.User };

    // StudentInfo.StudentInfo.DOB = new Date(
    //   StudentInfo?.StudentInfo?.DOB
    // ).toLocaleDateString();

    dispatch({
      type: "GetAboutClientSuccess",
      CoursePackage: data?.EnrolledCourse?.CoursePackage,
      Student: data?.EnrolledCourse?.User,
      // CourseProgress: data.EnrolledCourse.CourseProgress,
      CourseProgress: data?.Progress,

      ScheduleTimeTable: data?.EnrolledCourse?.ParsedSchedule,
      StudentInfo: data?.StudentInfoData,
    });
  } catch (error) {
    CheckLoginServer(error?.response?.data, dispatch);
    dispatch({
      type: "GetAboutClientFailure",
      payload: error,
    });
  }
};

export const CreateCoursesA =
  (CourseFormData, setSuccess) => async (dispatch) => {
    try {
      dispatch({
        type: "CreateCourseRequest",
      });

      const { data } = await axiosInstance.post(
        `/api/institute/course/add`,
        CourseFormData
      );

      setSuccess(true);
      dispatch({
        type: "CreateCourseSuccess",
        payload: data,
      });
    } catch (error) {
      CheckLoginServer(error?.response?.data, dispatch);
      dispatch({
        type: "CreateCourseFailure",
        payload: error,
      });
    }
  };

// export const InstituteCoursesA = () => async (dispatch) => {
//   try {
//     dispatch({
//       type: "GetInstituteCoursesRequest",
//     });

//     const { data } = await axiosInstance.get(`/api/institute/courses`);

//     dispatch({
//       type: "GetInstituteCoursesSuccess",
//       payload: data,
//     });
//   } catch (error) {
//     CheckLoginServer(error?.response?.data, dispatch);
//     dispatch({
//       type: "GetInstituteCoursesFailure",
//       payload: error,
//     });
//   }
// };
export const InstituteCoursesA = (page = 1, filter = 'All Courses') => async (dispatch) => {
  try {
    dispatch({
      type: "GetInstituteCoursesRequest",
    });

    const params = {
      page,
      limit: 100, // You can change the limit as needed
    };

    if (filter !== 'All Courses') {
      params.filter = filter;
    }

    const { data } = await axiosInstance.get(`/api/institute/courses`, { params });

    dispatch({
      type: "GetInstituteCoursesSuccess",
      payload: data,
    });
  } catch (error) {
    CheckLoginServer(error?.response?.data, dispatch);
    dispatch({
      type: "GetInstituteCoursesFailure",
      payload: error,
    });
  }
};

export const InstitutePendingCoursesA = () => async (dispatch) => {
  try {
    dispatch({
      type: "GetInstitutePendingCoursesRequest",
    });

    const { data } = await axiosInstance.get(`/api/institute/courses/pending`);

    dispatch({
      type: "GetInstitutePendingCoursesSuccess",
      payload: data,
    });
  } catch (error) {
    CheckLoginServer(error?.response?.data, dispatch);
    dispatch({
      type: "GetInstitutePendingCoursesFailure",
      payload: error,
    });
  }
};


export const InstituteCoursesCountA = () => async (dispatch) => {
  try {
    dispatch({
      type: "GetInstituteCoursesCountRequest",
    });

    const { data } = await axiosInstance.get(`/api/institute/courses/count`);

    dispatch({
      type: "GetInstituteCoursesCountSuccess",
      payload: data,
    });
  } catch (error) {
    CheckLoginServer(error?.response?.data, dispatch);
    dispatch({
      type: "GetInstituteCoursesCountFailure",
      payload: error,
    });
  }
};

export const UpdateCoursesA =
  (CourseFormData, setSuccess) => async (dispatch) => {
    try {
      dispatch({
        type: "CreateCourseRequest",
      });

      const { data } = await axiosInstance.put(
        `/api/institute/course/update`,
        CourseFormData
      );

      setSuccess(true);
      dispatch({
        type: "CreateCourseSuccess",
        payload: data,
      });
    } catch (error) {
      CheckLoginServer(error?.response?.data, dispatch);
      dispatch({
        type: "CreateCourseFailure",
        payload: error,
      });
    }
  };

export const DeleteInstituteCoursesA =
  (InstituteCourseId) => async (dispatch) => {
    try {
      dispatch({
        type: "GetInstituteCoursesRequest",
      });

      const { data } = await axiosInstance.delete(
        `/api/institute/course/remove`,
        { data: { InstituteCourseId } }
      );

      dispatch({
        type: "GetInstituteCoursesSuccess",
        payload: data,
      });
    } catch (error) {
      CheckLoginServer(error?.response?.data, dispatch);
      dispatch({
        type: "GetInstituteCoursesFailure",
        payload: error,
      });
    }
  };

// get student package to know about the pickup service
export const GetStudentCoursePackageFields = (EnrollmentId) => async (dispatch) => {
  try {
    console.log("EnrollmentId in GetStudentCoursepackageFields is:",EnrollmentId)
    dispatch({
      type: "GetSEnrolledStudentCoursePackageFieldsRequest",
    });
    const { data } = await axiosInstance.get(
      `/api/enrollCoursePackageFields/${EnrollmentId}`
    );
    console.log("senrol", data);
    dispatch({
      type: "GetSEnrolledStudentCoursePackageFieldsSuccess",
      payload: data,
    });
  } catch (error) {
    CheckLoginServer(error?.response?.data, dispatch);
    dispatch({
      type: "GetSEnrolledStudentCoursePackageFieldsFailure",
      payload: error,
    });
  }
};

// get student pickup service offers 
export const GetStudentPickupServiceOffers = (UserId, EnrollmentId) => async (dispatch) => {
  try {
    console.log("UserId in GetStudentPickupServiceOffers is:",UserId)
    dispatch({
      type: "GetSEnrolledPickupServiceOffersRequest",
    });
    const { data } = await axiosInstance.post(
      `/api/GetStudentPickupServiceOffers/${UserId}`,
      { EnrollmentId }
    );
    console.log("senrol", data);
    dispatch({
      type: "GetSEnrolledPickupServiceOffersSuccess",
      payload: data,
    });
  } catch (error) {
    CheckLoginServer(error?.response?.data, dispatch);
    dispatch({
      type: "GetSEnrolledPickupServiceOffersFailure",
      payload: error,
    });
  }
};

// get student pickup service offers 
export const GetStudentUpdatePickupLocationRequests = (UserId, EnrollmentId) => async (dispatch) => {
  try {
    console.log("UserId in GetStudentUpdatePickupLocationRequests is:",UserId)
    dispatch({
      type: "GetSEnrolledStudentUpdatePickupLocationRequest",
    });
    const { data } = await axiosInstance.post(
      `/api/GetStudentUpdatePickupLocationRequests/${UserId}`,
      { EnrollmentId }
    );
    console.log("senrol", data);
    dispatch({
      type: "GetSEnrolledStudentUpdatePickupLocationSuccess",
      payload: data,
    });
  } catch (error) {
    CheckLoginServer(error?.response?.data, dispatch);
    dispatch({
      type: "GetSEnrolledStudentUpdatePickupLocationFailure",
      payload: error,
    });
  }
};

// update student pickup service offers Status
export const UpdateStudentPickupServiceOffersStatus = (UserId,action, EnrollmentId) => async (dispatch) => {
  try {
    console.log("UserId in UpdateStudentPickupServiceOffersStatus is:",UserId)
    console.log("action in UpdateStudentPickupServiceOffersStatus is:",action)

    dispatch({
      type: "UpdateEnrolledStudentPickupServiceStatusRequest",
    });
    const { data } = await axiosInstance.post(
      `/api/UpdateStudentPickupServiceOffersStatus/${UserId}`,
      {action, EnrollmentId}
    );
    console.log("senrol", data);
    dispatch({
      type: "UpdateEnrolledStudentPickupServiceStatusSuccess",
      payload: data,
    });
    return Promise.resolve(); // Indicate success
  } catch (error) {
    CheckLoginServer(error?.response?.data, dispatch);
    dispatch({
      type: "UpdateEnrolledStudentPickupServiceStatusFailure",
      payload: error,
    });
    return Promise.reject(); // Indicate failure
  }
};

// send update pickuplocation request
export const sendStudentUpdatePickupLocationRequest = (UserId, EnrollmentId, studentAddress, updatedAddress) => async (dispatch) => {
  try {
    console.log("UserId in sendStudentUpdatePickupLocationRequest is:",UserId)

    dispatch({
      type: "UpdateEnrolledStudentPickupServiceStatusRequest",
    });
    const { data } = await axiosInstance.post(
      `/api/sendStudentUpdatePickupLocationRequest/${UserId}`,
      {EnrollmentId,studentAddress, updatedAddress}
    );
    console.log("senrol", data);
    dispatch({
      type: "UpdateEnrolledStudentPickupServiceStatusSuccess",
      payload: data,
    });
    return Promise.resolve(); // Indicate success
  } catch (error) {
    CheckLoginServer(error?.response?.data, dispatch);
    dispatch({
      type: "UpdateEnrolledStudentPickupServiceStatusFailure",
      payload: error,
    });
    return Promise.reject(); // Indicate failure
  }
};

// update student pickup service offers Status
export const UpdateStudentPickupLocationRequestStatus = (UserId,action, EnrollmentId) => async (dispatch) => {
  try {
    console.log("UserId in UpdateStudentPickupLocationRequestStatus is:",UserId)
    console.log("action in UpdateStudentPickupLocationRequestStatus is:",action)

    dispatch({
      type: "UpdateEnrolledStudentPickupServiceStatusRequest",
    });
    const { data } = await axiosInstance.post(
      `/api/UpdateStudentPickupLocationRequestStatus/${UserId}`,
      {action, EnrollmentId}
    );
    console.log("senrol", data);
    dispatch({
      type: "UpdateEnrolledStudentPickupServiceStatusSuccess",
      payload: data,
    });
    return Promise.resolve(); // Indicate success
  } catch (error) {
    CheckLoginServer(error?.response?.data, dispatch);
    dispatch({
      type: "UpdateEnrolledStudentPickupServiceStatusFailure",
      payload: error,
    });
    return Promise.reject(); // Indicate failure
  }
};

//GetCoursePaymentDetails Action
export const GetCoursePaymentDetails = (EnrollmentId, UserId) => async (dispatch) => {
  try {
    console.log("EnrollmentId in GetCoursePaymentDetails is:",EnrollmentId)

    dispatch({
      type: "GetCoursePaymentDetailsRequest",
    });
    const { data } = await axiosInstance.post(
      `/api/GetCoursePaymentDetailsData/${EnrollmentId}`,
      {UserId}
    );
    dispatch({
      type: "GetCoursePaymentDetailsSuccess",
      payload: data,
    });
  } catch (error) {
    CheckLoginServer(error?.response?.data, dispatch);
    dispatch({
      type: "GetCoursePaymentDetailsFailure",
      payload: error,
    });
  }
};

//GetPaymentInvoiceData Action
export const GetInvoicePaymentInstallmentsData = (paymentId, UserId) => async (dispatch) => {
  try {
    console.log("paymentId in GetInvoicePaymentInstallmentsData is:",paymentId)

    dispatch({
      type: "GetPaymentInvoiceDataRequest",
    });
    const { data } = await axiosInstance.post(
      `/api/GetInvoicePaymentInstallmentsData/${paymentId}`,
      { UserId }
    );
    dispatch({
      type: "GetPaymentInvoiceDataSuccess",
      payload: data,
    });
  } catch (error) {
    CheckLoginServer(error?.response?.data, dispatch);
    dispatch({
      type: "GetPaymentInvoiceDataFailure",
      payload: error,
    });
  }
};


//GetCourseCertificateData Action
export const GetCourseCertificateData = (enrollmentId, UserId) => async (dispatch) => {
  try {
    console.log("enrollmentId in GetCourseCertificateData is:",enrollmentId)

    dispatch({
      type: "GetCourseCertificateDataRequest",
    });
    const { data } = await axiosInstance.post(
      `/api/GetCourseCertificateData/${enrollmentId}`,
      { UserId }
    );
    dispatch({
      type: "GetCourseCertificateDataSuccess",
      payload: data,
    });
  } catch (error) {
    CheckLoginServer(error?.response?.data, dispatch);
    dispatch({
      type: "GetCourseCertificateDataFailure",
      payload: error,
    });
  }
};

//GetEnrollmentFKfromCertificateId Action
export const GetEnrollmentFKfromCertificateId = (CertificateId) => async (dispatch) => {
  try {
    console.log("CertificateId in GetEnrollmentFKfromCertificateId is:",CertificateId)

    dispatch({
      type: "GetEnrollmentFKfromCertificateIdRequest",
    });
    const { data } = await axiosInstance.post(
      `/api/GetEnrollmentFKfromCertificateId/${CertificateId}`,
    );
    dispatch({
      type: "GetEnrollmentFKfromCertificateIdSuccess",
      payload: data,
    });
  } catch (error) {
    CheckLoginServer(error?.response?.data, dispatch);
    dispatch({
      type: "GetEnrollmentFKfromCertificateIdFailure",
      payload: error,
    });
  }
};

//VerifyCerificateData Action
// export const VerifyCertificateData = (studentId, emailId, lastName) => async (dispatch) => {
//   try {
//     console.log("studentId in VerifyCertificateData is:",studentId)
//     console.log("emailId in VerifyCertificateData is:",emailId)
//     console.log("lastName in VerifyCertificateData is:",lastName)

//     dispatch({
//       type: "VerifyCerificateDataRequest",
//     });
//     const { data } = await axiosInstance.post(
//       `/api/VerifyCerificateData`,
//       {studentId, emailId, lastName}
//     );
//     dispatch({
//       type: "VerifyCerificateDataSuccess",
//       payload: data,
//     });
//   } catch (error) {
//     CheckLoginServer(error?.response?.data, dispatch);
//     dispatch({
//       type: "VerifyCerificateDataFailure",
//       payload: error,
//     });
//   }
// };

export const VerifyCertificateData = (studentId, emailId, lastName) => async (dispatch) => {
  try {
    console.log("studentId in VerifyCertificateData is:", studentId);
    console.log("emailId in VerifyCertificateData is:", emailId);
    console.log("lastName in VerifyCertificateData is:", lastName);

    dispatch({
      type: "VerifyCerificateDataRequest",
    });

    const { data } = await axiosInstance.post(`/api/VerifyCerificateData`, { studentId, emailId, lastName });

    dispatch({
      type: "VerifyCerificateDataSuccess",
      payload: data,
    });
  } catch (error) {
    CheckLoginServer(error?.response?.data, dispatch);

    dispatch({
      type: "VerifyCerificateDataFailure",
      payload: error.response?.data?.message || "Something went wrong.", // Store only message
    });
  }
};


/// CreateInstituteCourseStep1A
export const CreateInstituteCourseStep1A = (formData, InstituteId, onSuccess, onError) => async (dispatch) => {
  try {
      dispatch({
          type: "CreateInstituteCourseStep1Request",
      });

      const { data } = await axiosInstance.post(
          `/api/institute/course/create-step-1/${InstituteId}`,
          formData,
          {
              headers: {
                  "Content-Type": "multipart/form-data" // Ensure correct headers
              }
          }
      );

      dispatch({
          type: "CreateInstituteCourseStep1Success",
          payload: data,
      });

      // cb();
      if (onSuccess) onSuccess(); // ✅ resolve
  } catch (error) {
      dispatch({
          type: "CreateInstituteCourseStep1Failure",
          payload: error?.response?.data ? error?.response?.data : {},
      });

      if (onError) onError(error?.response?.data?.message || "Submission failed"); // ✅ reject
  }
};

export const CreateInstituteCourseStep2A = (packages, CourseId, InstituteId, onSuccess, onError) => async (dispatch) => {
  try {
      dispatch({
          type: "CreateInstituteCourseStep2Request",
      });

      const { data } = await axiosInstance.post(
          `/api/institute/course/create-step-2/${InstituteId}`,
          { packages, CourseId },
      );

      dispatch({
          type: "CreateInstituteCourseStep2Success",
          payload: data,
      });

      // cb();
      if (onSuccess) onSuccess(); // ✅ resolve
  } catch (error) {
      dispatch({
          type: "CreateInstituteCourseStep2Failure",
          payload: error?.response?.data ? error?.response?.data : {},
      });

      if (onError) onError(error?.response?.data?.message || "Submission failed"); // ✅ reject
  }
};

export const CreateInstituteCourseStep3A = (instructors , CourseId, InstituteId, onSuccess, onError) => async (dispatch) => {
  try {
      dispatch({
          type: "CreateInstituteCourseStep2Request",
      });

      const { data } = await axiosInstance.post(
          `/api/institute/course/create-step-3/${InstituteId}`,
          { instructors , CourseId },
      );

      dispatch({
          type: "CreateInstituteCourseStep2Success",
          payload: data,
      });

      // cb();
      if (onSuccess) onSuccess(); // ✅ resolve
  } catch (error) {
      dispatch({
          type: "CreateInstituteCourseStep2Failure",
          payload: error?.response?.data ? error?.response?.data : {},
      });

      if (onError) onError(error?.response?.data?.message || "Submission failed"); // ✅ reject
  }
};

export const CreateInstituteCourseStep4A = (vehicles, CourseId, InstituteId, status, onSuccess, onError) => async (dispatch) => {
  try {
      dispatch({
          type: "CreateInstituteCourseStep2Request",
      });

      const { data } = await axiosInstance.post(
          `/api/institute/course/create-step-4/${InstituteId}`,
          { vehicles , CourseId, status },
      );

      dispatch({
          type: "CreateInstituteCourseStep2Success",
          payload: data,
      });

      // cb();
      if (onSuccess) onSuccess(); // ✅ resolve
  } catch (error) {
      dispatch({
          type: "CreateInstituteCourseStep2Failure",
          payload: error?.response?.data ? error?.response?.data : {},
      });

      if (onError) onError(error?.response?.data?.message || "Submission failed"); // ✅ reject
  }
};

export const DeleteInstituteCourseA = (InstituteCourseId, onSuccess, onError) => async (dispatch) => {
  try {
      dispatch({
          type: "DeleteInstituteCourseRequest",
      });

      const { data } = await axiosInstance.post(
          `/api/institute/course/delete/${InstituteCourseId}`,
      );

      dispatch({
          type: "DeleteInstituteCourseSuccess",
          payload: data,
      });

      // cb();
      if (onSuccess) onSuccess(); // ✅ resolve
  } catch (error) {
      dispatch({
          type: "DeleteInstituteCourseFailure",
          payload: error?.response?.data ? error?.response?.data : {},
      });

      if (onError) onError(error?.response?.data?.message || "Submission failed"); // ✅ reject
  }
};



export const GetInstituteAutomaticTrainingHoursGeneration = (InstituteCourseId) => async (dispatch) => {
  dispatch({ type: "GetInstituteAutomaticTrainingHoursGenerationRequest" });

  try {
      const response = await axiosInstance.get(
        `/api/institute/AutomaticTrainingHoursGeneration/${InstituteCourseId}`
      ); // Replace with actual API call
      dispatch({
          type: "GetInstituteAutomaticTrainingHoursGenerationSuccess",
          payload: response.data, // The time slots data
      });
  } catch (error) {
      dispatch({
          type: "GetInstituteAutomaticTrainingHoursGenerationFailure",
          payload: error.response?.data || error.message,
      });
  }
};